import React from "react";
import styled from "styled-components";
import { colors } from "../colors/color";

export function ScrollContainer (props: { maxHeightPx?: number; children: React.ReactNode; }): JSX.Element
{
    if (props.maxHeightPx !== undefined)
    {
        return (
            <StyledScrollContainer maxHeightPx={props.maxHeightPx}>
                {props.children}
            </StyledScrollContainer>
        );
    }
    else
    {
        return (
            <>
                {props.children}
            </>
        );
    }
}

const StyledScrollContainer = styled.div<{maxHeightPx: number}>`
    max-height: ${props => props.maxHeightPx}px;
    overflow-y: auto;
    border: 1px solid #ffff;

    :hover {
        border: 1px solid ${colors.scrollContainer.borderHover};
        transition: border 0.5s;
    }
`;